module.exports = __webpack_public_path__ + "static/media/HomePage@1x.31452ce0.jpg";